"use client"

import { useIntersectionObserver } from "./use-intersection"
import { useCounterAnimation } from "./use-counter-animation"

export function ExpertiseStats() {
  const { ref, hasIntersected } = useIntersectionObserver()

  const projectsCount = useCounterAnimation(500, 2000, hasIntersected)
  const experienceCount = useCounterAnimation(5, 1500, hasIntersected)
  const satisfactionCount = useCounterAnimation(100, 2500, hasIntersected)

  const stats = [
    {
      count: projectsCount,
      suffix: "+",
      label: "Projects",
      description: "Successfully completed projects across various industries",
    },
    {
      count: experienceCount,
      suffix: "+",
      label: "Years Experience",
      description: "Years of expertise in digital solutions",
    },
    {
      count: satisfactionCount,
      suffix: "%",
      label: "Client Satisfaction",
      description: "Client satisfaction rate with our services",
    },
  ]

  return (
    <section className="py-10 sm:py-16 px-4 bg-rose-50">
      <div className="max-w-7xl mx-auto text-center mb-8 sm:mb-12">
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-4 px-2">
          Our <span className="text-blue-600">Expertise</span>
        </h2>
      </div>

      <div ref={ref} className="bg-gradient-to-r from-blue-600 to-blue-700 rounded-xl sm:rounded-2xl p-6 sm:p-8 lg:p-12">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 sm:gap-8 lg:gap-12">
          {stats.map((stat, index) => (
            <div key={index} className="text-center group hover:scale-105 transition-transform duration-300 py-2 sm:py-0">
              <div className="text-3xl sm:text-4xl lg:text-6xl font-bold text-white mb-1 sm:mb-2 font-mono">
                {stat.count}
                {stat.suffix}
              </div>
              <div className="text-base sm:text-xl lg:text-2xl font-semibold text-blue-100 mb-2 sm:mb-3">{stat.label}</div>
              <div className="text-blue-200 text-xs sm:text-sm lg:text-base leading-relaxed opacity-0 group-hover:opacity-100 transition-opacity duration-300 max-w-xs mx-auto">
                {stat.description}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
